import { endpoints } from '@api'
import { Box, Heading } from '@chakra-ui/react'
import { SearchSelect } from '@components'
import { DateTime } from 'luxon'
import moment from 'moment-timezone'
import React from 'react'
import { useQueryClient } from 'react-query'
import { useClinicControllerUpdateClinicTimezone } from '~/clinician-api'

const now = DateTime.now()

const zones = moment.tz.names()

const zoneList: { label: string; value: string }[] = []

zones.forEach((zone: string) => {
  try {
    const dt = now.setZone(zone)
    const offsetHours = dt.offset / 60
    const offsetFormatted = `UTC${
      offsetHours >= 0 ? '+' : ''
    }${offsetHours.toString().padStart(2, '0')}:00`
    const longName = dt.offsetNameLong
    const shortName = dt.offsetNameShort

    const label = `${longName} (${shortName}) - ${offsetFormatted} [${zone}]`

    zoneList.push({
      label,
      value: zone
    })
  } catch (e) {
    // skip invalid zones
  }
})

export const SelectTimezone = ({ clinic }: { clinic: any }) => {
  const queryClient = useQueryClient()

  const { mutate: updateClinicTimezone } =
    useClinicControllerUpdateClinicTimezone({
      mutation: {
        onSuccess: () => {
          queryClient.invalidateQueries(
            endpoints.getOrganizationClinics.getCacheId()
          )
        }
      }
    })

  return (
    <Box w="100%">
      <Heading size="small" mb="small">
        Timezone
      </Heading>
      <SearchSelect
        value={zoneList.find(zone => zone.value === clinic.timezone)}
        size="large"
        maxHeight="170px"
        onChange={(option: { label: string; value: string }) => {
          updateClinicTimezone({
            clinicId: clinic.id,
            data: {
              timezone: option.value
            }
          })
        }}
        onSearch={() => {}}
        placeholder="Select a timezone"
        options={zoneList}
        errors={null}
      />
    </Box>
  )
}
